import request from '@/utils/request';
// 编辑安装来源
export const editInstallScource = (data: any) =>
  request({
    url: 'InstallSource/installSource',
    method: 'PUT',
    data
  });
// 删除安装来源
export const delInstallScource = (data: any) =>
  request({
    url: 'InstallSource/installSource',
    method: 'DELETE',
    data
  });
// 添加安装来源
export const addInstallScource = (data: any) =>
  request({
    url: 'InstallSource/installSource',
    method: 'POST',
    data
  });
// 获取安装来源列表
export const getInstallScourceList = (params: any) =>
  request({
    url: 'InstallSource/installSourceList',
    method: 'get',
    params
  });
